import React, { createContext, useContext } from 'react';
import { translations, Language } from './translations';

interface LanguageContextType {
  language: Language;
  t: (key: keyof typeof translations['en']) => string;
}

export const LanguageContext = createContext<LanguageContextType>({
  language: 'en',
  t: (key) => translations['en'][key],
});

export const useLanguage = () => useContext(LanguageContext); 